/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app'
// });

require('@fortawesome/fontawesome-pro/js/fontawesome');
require('@fortawesome/fontawesome-pro/js/brands');
require('@fortawesome/fontawesome-pro/js/regular');

// require('./components/form-modal');
require('devbridge-autocomplete/src/jquery.autocomplete.js');
// require('devbridge-autocomplete');
// require('@sergiovilar/jquery-pjax');
require('jquery-pjax');
// require('jquery-parallax.js');
require('jquery.scrollto');
require('jquery.localscroll');
// require('sortablejs');
// require('x-editable/dist/bootstrap3-editable/js/bootstrap-editable.min.js');
require('bootstrap-datepicker');
require('bootstrap-timepicker');
require('jquery-zoom');
require('caroufredsel');
require('./vendor/bootstrap-tab-history/bootstrap-tab-history');
require('selectize');

// require('waypoints/lib/jquery.waypoints.min');
// require('waypoints/lib/shortcuts/inview');
require('readmore-js/resources/readmore');

require('./typeahead');

require('./misc');


// window.Slideout = require('slideout');

window.sprintf = require('sprintf-js').sprintf;

window.moment = require('moment');

window.queryString = require('query-string');

// use forked temporary for bootstrap 4
// window.bootbox = require('bootbox');
window.bootbox = require('bootbox/src/bootbox.js');

window.NProgress = require('nprogress');

window.ajaxFormRequest = function (param) {
  let msg;
  if (typeof(param.target) == 'undefined') param.target = '#ajax-modal';

  let $target = $(param.target);

  $.ajax({
    url: param.url,
    type: "GET",
    dataType: "json",//expect json as return
    beforeSend: function (jqXHR, settings) {
      msg = Messenger().post({
        message: 'Processing...',
        type: 'info',
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true,
        singleton: true
      });
    },
    error: function (e) {
      let message = '';

      if (e.hasOwnProperty('responseJSON')) {
        message = sprintf('%s %s', e.responseJSON.hasOwnProperty('exception') ? e.responseJSON.exception + '.' : '', e.responseJSON.message);
      } else if(e.hasOwnProperty('responseText')) {
        message = e.responseText;
      }

      msg.update({
        message: sprintf('Error encountered. <div class="mt-20">%s</div>', message),
        type: 'error'
      });

      $target.modal('hide');

      setTimeout(function () {
        msg.hide();
      }, 5000);
    },
    success: function (result) {
      if (result.hasOwnProperty('html')) {
        $target.find('.modal-body').html(result.html);

        setTimeout(function () {
          $target.find('form :input:enabled:visible:first').focus();
        }, 250);
      }

      if (typeof(param.successShown) != 'undefined' && typeof(param.successShown) === "function")
        param.successShown(result, $target);

      if (result.success != null && !result.success) {
        msg.update({message: result.message, type: 'error'});
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({message: result.message, type: 'success'});
        } else {
          msg.update({message: 'Done!', type: 'success'});
        }
      }

      $target.trigger('fetched.modal', [result, $target]);

      setTimeout(function () {
        msg.hide();
      }, 500);
    }
  });
}

window.ajaxRequest = function (param) {
  let msg;

  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("notification")) param.notification = {successDelay: 500, errorDelay: 2000};
  if (!param.hasOwnProperty("data")) param.data = null;

  $.ajax({
    url: param.url,
    type: param.type,
    dataType: "json",//expect json as return
    data: param.data,
    beforeSend: function (jqXHR, settings) {
      if (param.hasOwnProperty("anchor")) {
        param.anchor.data('original-text', param.anchor.html());
        param.anchor.html('<i class="spinners"></i>');
      }

      msg = Messenger().post({
        message: 'Processing...',
        type: 'info',
        hideAfter: 20,
        showCloseButton: true,
        hideOnNavigate: true
      });

      if (param.beforeSend && typeof(param.beforeSend) === "function") param.beforeSend(jqXHR, settings);
    },
    error: function (e) {
      if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

      msg.update({
        message: sprintf('Error encountered. <div class="mt-20">%s %s</div>', (e.responseJSON.hasOwnProperty('exception')) ? e.responseJSON.exception + '.' : '', e.responseJSON.message),
        type: 'error'
      });

      if (param.error && typeof(param.error) === "function") param.error(e);

      setTimeout(function () {
        msg.hide();
      }, 5000);
    },
    success: function (result) {
      if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

      // if(result.hasOwnProperty('html')) $('.bootbox .modal-body').html(result.html);
      if (typeof(param.successShown) != 'undefined' && typeof(param.successShown) === "function") param.successShown(result);

      if (result.success != null && !result.success) {
        msg.update({message: result.message, type: 'error'});
      } else {
        if (result.message != null && result.message.length > 0) {
          msg.update({message: result.message, type: 'success'});
        } else {
          msg.update({message: 'Done!', type: 'success'});
        }

        if (result.success && (param.success && typeof(param.success) === "function")) param.success(result);
      }

      setTimeout(function () {
        msg.hide();
      }, (result.success) ? param.notification.successDelay : param.notification.errorDelay);
    }
  });
};

window.ajaxPost = function (param) {
  if (!param.hasOwnProperty("type")) param.type = "GET";
  if (!param.hasOwnProperty("data")) param.data = null;
  if (!param.hasOwnProperty("btnCancel")) param.btnCancel = {label: "Cancel", className: "btn-default"};
  if (!param.hasOwnProperty("notification")) param.notification = {successDelay: 500, errorDelay: 2000};
  if (!param.hasOwnProperty("activeModal")) param.activeModal = false;

  if (!param.notification.hasOwnProperty("successDelay")) param.notification.successDelay = 500;
  if (!param.notification.hasOwnProperty("errorDelay")) param.notification.errorDelay = 2000;

  let msg;

  bootbox.dialog({
    message: param.message,
    title: param.title,
    buttons: {
      cancel: {label: param.btnCancel.label, className: param.btnCancel.className},
      main: {
        label: param.btnMain.label,
        className: param.btnMain.className,
        callback: function () {
          $.ajax({
            url: param.url,
            type: param.type,//request is a POSt request
            dataType: "json",//expect json as return
            data: param.data,
            beforeSend: function (jqXHR, settings) {
              if (param.hasOwnProperty("anchor")) {
                param.anchor.data('original-text', param.anchor.html());
                param.anchor.html('<i class="spinners"></i> Loading ...');
              }

              if (param.activeModal)
                $('.bootbox .modal-body').html('<i class="spinners"></i> Loading ...');

              msg = Messenger().post({
                message: '<i class="spinners"></i> Processing...',
                type: 'info',
                hideAfter: 20,
                showCloseButton: true,
                hideOnNavigate: true,
                singleton: true
              });

              if (param.beforeSend && typeof(param.beforeSend) === "function") param.beforeSend(jqXHR, settings);
            },
            error: function (e) {
              if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

              let message = '';

              if (e.hasOwnProperty('responseJSON')) {
                message = sprintf('%s %s', e.responseJSON.hasOwnProperty('exception') ? e.responseJSON.exception + '.' : '', e.responseJSON.message);
              } else if(e.hasOwnProperty('responseText')) {
                message = e.responseText;
              }

              msg.update({
                message: sprintf('Error encountered. <div class="mt-20">%s</div>', message),
                type: 'error'
              });

              if (param.error && typeof(param.error) === "function") param.error(e);

              setTimeout(function () {
                msg.hide();
              }, 5000);
            },
            success: function (result) {
              if (param.hasOwnProperty("anchor")) param.anchor.html(param.anchor.data('original-text'));

              if (result.hasOwnProperty('html')) $('.bootbox .modal-body').html(result.html);

              if (typeof(param.successShown) != 'undefined' && typeof(param.successShown) === "function") param.successShown(result);

              if (result.success != null && !result.success) {
                msg.update({message: result.message, type: 'error'});
              } else {
                if (result.message != null && result.message.length > 0) {
                  msg.update({message: result.message, type: 'success'});
                } else {
                  msg.update({message: 'Done!', type: 'success'});
                }

                if (result.success && (param.success && typeof(param.success) === "function")) param.success(result);
              }

              setTimeout(function () {
                msg.hide();

                if (param.activeModal)
                  bootbox.hideAll();
              }, (result.success) ? param.notification.successDelay : param.notification.errorDelay);
            }
          });

          if (param.activeModal) return false;
        }
      }
    }
  });
};

window.ajaxFormModal = function (param) {
  param = typeof(param) != 'undefined' ? param : {autoClose: false};

  if (typeof(param.container) == 'undefined') param.container = '#ajax-modal';

  var options = {
    dataType: 'json',
    //target:        '#ajax-form-container',
    delegation: true,
    beforeSerialize: function ($form, options) {
      if (typeof(param.beforeSerialize) != 'undefined' && typeof(param.beforeSerialize) === "function") param.beforeSerialize($form, options, $(param.container));
    },
    beforeSubmit: function (arr, $form, options) {
      $(param.container + ' .modal-body').html('<i class="spinners"></i> Loading..');

      if (typeof(param.beforeSubmit) != 'undefined' && typeof(param.beforeSubmit) === "function") param.beforeSubmit(arr, $form, options, $(param.container));
    },
    error: function (e) {
      // $(param.container + ' .modal-body').html(sprintf('Error encountered. <div class="mt-3">%s %s</div>', (e.responseJSON.hasOwnProperty('exception')) ? e.responseJSON.exception + '.' : '', e.responseJSON.message));
      $(param.container + ' .modal-body').html(sprintf('<span class="text-danger">Error encountered</span> <div class="mt-1">%s</div>', e.responseJSON.message));
    },
    success: function (result, status) {
      $(param.container + ' .modal-body').html(result.html);

      $(param.container).find('form :input:enabled:visible:first').focus();

      if (typeof(param.successShown) != 'undefined' && typeof(param.successShown) === "function")
        param.successShown(result);
      else
        $(param.container).trigger('shown.bs.modal');

      // flag to handle callback action after ajax request in dialog form
      window.form_success = (result.success) ? true : false;

      $(param.container).trigger('fetched.modal', [result, $(param.container)]);

      if (result.success && param.autoClose !== false) {
        setTimeout(function () {
          $(param.container).modal('hide');
        }, param.autoClose);
      }

      if (!result.hasOwnProperty("model")) result["model"] = null;

      if (param.hasOwnProperty("relatedTarget")) result["relatedTarget"] = param.relatedTarget;

      if (result.success && (param.success && typeof(param.success) === "function")) param.success(result, $(param.container));
    }

    // other available options:
    //url:       url         // override for form's 'action' attribute
    //type:      type        // 'get' or 'post', override for form's 'method' attribute
    //dataType:  null        // 'xml', 'script', or 'json' (expected server response type)
    //clearForm: true        // clear all form fields after successful submit
    //resetForm: true        // reset the form after successful submit

    // $.ajax options can be used here too, for example:
    //timeout:   3000
  };

  // bind form using 'ajaxForm'
  var target = param.container + ' form';

  $(target).ajaxForm(options);


  $(param.container).on('show.bs.modal', function (e) {
    if (typeof(e.relatedTarget) !== 'undefined') {
      param.relatedTarget = e.relatedTarget;
    }

    if (typeof(param.show) != 'undefined' && typeof(param.show) === "function") {
      param.show(e, $(param.container));
    }
  });

  if (typeof(param.fetched) != 'undefined' && typeof(param.fetched) === "function") {
    $(param.container).on('fetched.modal', function (e, response, $modal) {
      param.fetched(e, response, $modal);
    });
  }

  if (typeof(param.shown) != 'undefined' && typeof(param.shown) === "function") {
    $(param.container).on('shown.bs.modal', function (e) {
      // delay trigger callback to wait all have been inited on slower machine
      setTimeout(function () {
        param.shown(e, $(param.container));
      }, 200);
    });
  }

  $(param.container).on('hidden.bs.modal', function (e) {
    $(this).removeData('bs.modal');
    $(this).find('.modal-body').html('<i class="spinners"></i> Loading...');

    if (typeof(param.hidden) != 'undefined' && typeof(param.hidden) === "function") {
      param.hidden(e, $(param.container));
    }
  });
};

window.ajaxPagination = function (param) {
  const target = param.target;
  const linkSelector = param.links;

  $('#container').on('click', linkSelector, function(e) {
    ajaxRequest({
      url: $(this).attr('href'),
      dataType: 'json',
      notification: {
        successDelay: 1000,
        errorDelay: 5000
      },
      beforeSend: function(){
        $(target).fadeTo(100, 0.5);
      },
      success: function(response) {
        $(target).html(response.html).fadeTo(100, 1);
      }
    });

    return false;
  });
}

window.copyUrlToClipboard = function (target) {
  $inputGroup = $(target).closest('.input-group');

  const el = document.createElement('textarea');
  // el.value = `${$inputGroup.find('.input-group-prepend > .input-group-text').text()}${$inputGroup.find('input#seo_url').val()}`;
  el.value = `${$inputGroup.find('input.copyable').val()}`;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);

  const selected =
    document.getSelection().rangeCount > 0
      ? document.getSelection().getRangeAt(0)
      : false;
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }

  msg = Messenger().post({
    message: 'Copied',
    type: 'success',
    hideAfter: 1,
    showCloseButton: true,
    hideOnNavigate: true,
    singleton: true
  });
}